import React from 'react';
import Dashboard from 'layouts/dashboard';
import Tables from 'layouts/tables';
import Billing from 'layouts/billing';
import RTL from 'layouts/rtl';
import Analysis from 'layouts/analysis';
import Notifications from 'layouts/notifications';
import Profile from 'layouts/profile';
import SignIn from 'layouts/authentication/sign-in';
import SignUp from 'layouts/authentication/sign-up';
import DrBullsheet from 'layouts/ai';
import FXBullsheetTradeOptimizerLayout from 'layouts/calculator';
import Backtesting from 'layouts/backtesting';
import Backtesting_v2 from 'layouts/backtesting_v2';
import BacktestingDashboard from 'layouts/backtestingdashboard';
import Charts from 'layouts/charts';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TableViewIcon from '@mui/icons-material/TableView';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CalculateIcon from '@mui/icons-material/Calculate';
import WaterfallChartIcon from '@mui/icons-material/WaterfallChart';
import LogoutIcon from '@mui/icons-material/Logout';
import Icon from '@mui/material/Icon';
import TradeEntryForm from './components/TradeEntryForm';
import ProtectedRoute from './ProtectedRoute';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SignUpPage from 'layouts/authentication/sign-up/SignUpPage';
import SubscriptionSuccess from 'layouts/authentication/sign-up/SubscriptionSuccess';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DiscountCodeManager from 'layouts/authentication/sign-up/DiscountCodeManager';
import Tutorials from './layouts/tutorials';
import SchoolIcon from '@mui/icons-material/School';
import AffiliateDashboard from 'layouts/affiliatedashboard';
import TradeAccountsOverview from 'layouts/TradeAccountsOverview';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import TeamDashboard from 'layouts/teamdashboard';
import GroupIcon from '@mui/icons-material/Group';
import TradeReplay from './components v2/TradeReplay';

const adminUserId = '4JkJV2u5InQeearkcPKfFkbC73s2';
const allowedRoles = ['coach', 'co-coach', 'admin'];

const allowedUserIds = [
  'BZqRPWxemaMLU4oFhGdnyuzapOh1',
  '4JkJV2u5InQeearkcPKfFkbC73s2',
  'tnfnwSzbqzRksTjo82bZAO0d4Ly2',
];

const routes = (props) => {
  const userId = localStorage.getItem('userID');
  const isLoggedIn = !!userId;
  const { isAffiliate, profileInfo } = props;

  return [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'fx-dashboard',
      icon: <DashboardIcon fontSize="small" />,
      route: '/fx-dashboard',
      component: Dashboard,
      protected: true,
    },
    {
      type: 'collapse',
      name: 'Trade Accounts',
      key: 'trade-accounts-overview',
      icon: <DashboardCustomizeIcon fontSize="small" />,
      route: '/trade-accounts-overview',
      component: TradeAccountsOverview,
      protected: true,
    },
    {
      type: 'collapse',
      name: 'Journal Entry',
      key: 'fx-dashboard/journal-entry',
      icon: <TableViewIcon fontSize="small" />,
      route: '/fx-dashboard/journal-entry',
      component: Tables,
      protected: true,
      demoRestricted: true,
    },
    {
      type: 'collapse',
      name: 'Charts',
      key: 'fx-dashboard/charts',
      icon: <AutoGraphIcon fontSize="small" />,
      route: '/fx-dashboard/charts',
      component: Charts,
      protected: true,
    },
    {
      type: 'collapse',
      name: 'Trade Diary',
      key: 'fx-dashboard/trade-diary',
      icon: <MenuBookIcon fontSize="small" />,
      route: '/fx-dashboard/trade-diary',
      component: Billing,
      protected: true,
      demoRestricted: true,
    },
    {
      type: 'collapse',
      name: 'Trade Optimizer',
      key: 'fx-dashboard/trade-optimizer',
      icon: <CalculateIcon fontSize="small" />,
      route: '/fx-dashboard/trade-optimizer',
      component: FXBullsheetTradeOptimizerLayout,
      protected: true,
      demoRestricted: true,
    },
    {
      type: 'collapse',
      name: 'Backtesting',
      key: 'fx-dashboard/backtesting',
      icon: <WaterfallChartIcon fontSize="small" />,
      route: '/fx-dashboard/backtesting',
      component: Backtesting_v2,
      protected: true,
    },
    {
      type: 'collapse',
      name: 'Backtest Analytics',
      key: 'fx-dashboard/backtesting-dashboard',
      icon: <AnalyticsIcon fontSize="small" />,
      route: '/fx-dashboard/backtesting-dashboard',
      component: BacktestingDashboard,
      protected: true,
      demoRestricted: true,
    },

    {
      type: 'collapse',
      name: 'Profile & Strategy',
      key: 'fx-dashboard/profile',
      icon: <PersonIcon fontSize="small" />,
      route: '/fx-dashboard/profile',
      component: Profile,
      protected: true,
    },
    {
      type: isAffiliate ? 'collapse' : 'hidden',
      name: 'Affiliate Dashboard',
      key: 'affiliate-dashboard',
      icon: <LocalOfferIcon fontSize="small" />,
      route: '/fx-dashboard/affiliate',
      component: AffiliateDashboard,
      protected: true,
    },
    {
      type: profileInfo?.role && allowedRoles.includes(profileInfo.role) ? 'collapse' : 'hidden',
      name: 'Team Dashboard',
      key: 'team-dashboard',
      icon: <GroupIcon fontSize="small" />,
      route: '/fx-dashboard/team',
      component: TeamDashboard,
      protected: true,
      allowedRoles: ['coach', 'co-coach', 'admin'],

    },
    {
      type: 'collapse',
      name: 'Tutorials',
      key: 'fx-dashboard/tutorials',
      icon: <SchoolIcon fontSize="small" />,
      route: '/fx-dashboard/tutorials',
      component: Tutorials,
      protected: true,
    },
    {
      type: 'hidden',
      name: 'Trade Replay',
      key: 'fx-dashboard/trade-replay',
      route: '/fx-dashboard/trade-replay/:tradeId',
      component: TradeReplay,
      protected: true,
      demoRestricted: true,
    },
    {
      type: 'hidden',
      name: 'Subscription Success',
      key: 'subscription-success',
      route: '/subscription-success',
      component: SubscriptionSuccess,
    },
    ...(!isLoggedIn || userId === adminUserId
      ? [
          {
            type: 'collapse',
            name: 'Sign Up',
            key: 'sign-up',
            icon: <PersonIcon fontSize="small" />,
            route: '/authentication/sign-up',
            component: SignUpPage,
          },
          {
            type: 'collapse',
            name: 'Discount Codes',
            key: 'discount-codes',
            icon: <LocalOfferIcon fontSize="small" />,
            route: '/admin/discount-codes',
            component: DiscountCodeManager,
            protected: true,
            allowedUserIds: [adminUserId],
          },
        ]
      : []),
    {
      type: 'collapse',
      name: isLoggedIn ? 'Sign Out' : 'Sign In',
      key: 'sign-in',
      icon: isLoggedIn ? <LogoutIcon fontSize="small" /> : <LoginIcon fontSize="small" />,
      route: '/authentication/sign-in',
      component: SignIn,
      protected: false,
    },
  ];
};

export default routes;